import React, { useState, useEffect } from "react";
import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
import toast from "react-hot-toast";
import RegularLoader from "../../Component/Loader/RegularLoader";
import { BASE_URL, GET_PINCODE } from "../../config/api";
import axios from "axios";

export default function CreateLeadForm({ onCreate }) {

  const [existingUserData, setExistingUserData] = useState(null);
  const [showExistingPopup, setShowExistingPopup] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUserData"));
  const sessionRole = authUser?.role;

  const ROLE_OPTIONS = ["company", "agent", "retailer"];
 
  const [selectedProducts, setSelectedProducts] = useState("");


  const toggleProductType = (type) => {
  setSelectedProducts((prev) => {
    const current = prev ? prev.split(",") : [];

    if (current.includes(type)) {
      // remove
      const updated = current.filter((t) => t !== type);
      return updated.join(",");
    } else {
      // add
      return [...current, type].join(",");
    }
  });
};


  // Filter role list based on logged-in user type
  const ROLE_VALUE_MAP = {
    MCP: 2,
    CP: 4,
    ARP: 5,
  };

  const applyHandleRestriction = (options) => {
    const isSalesCNF =
      authUser?.role === 3 && authUser?.type_of_user === "sales";

    // If not sales CNF or no handle → keep existing behavior
    if (!isSalesCNF || !authUser?.handle?.length) {
      return options;
    }

    // Normalize handle values
    const allowed = authUser.handle
      .flatMap(item => item.split(","))
      .map(r => r.trim().toLowerCase());

    return options.filter(opt => allowed.includes(opt));
  };


  // Keep your filteredRoleOptions logic as is
  const filteredRoleOptions = () => {
  const role = authUser?.role;
  const handle = authUser?.handle || [];
  const handles = Array.isArray(handle) ? handle : [handle];
  let options = [];

  // ✅ FIX HERE
  if (role === 1) options = ["MCP"]; // only company

  if (role === 2) options = ["CP"];
  if (role === 4) options = ["ARP"];

  if (role === 3) {
    if (handles.includes("AGENT") && handles.includes("RETAILER")) {
      return ["CP", "ARP"];
    }
    if (handles.includes("AGENT")) return ["CP"];
    if (handles.includes("RETAILER")) return ["ARP"];
  }

  return applyHandleRestriction(options);
};

  const [form, setForm] = useState({
  name: "",
  owner_first: "",
  owner_middle: "",
  owner_last: "",
  phone: "",
  state: "",
  district: "",
  pincode: "",
  email: "",
  address1: "",
  address2: "",
  lead_amount: "",
  status: STATUSES[0]?.value || "new",
  created_by_id: authUser?.id ?? "",
  created_by_name:
    authUser?.business_name ||
    `${authUser?.first_name ?? ""} ${authUser?.last_name ?? ""}`.trim(),
  lead_type: "",
  products:"",

});


  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [pinLoading, setPinLoading] = useState(false);
  const [packages, setPackages] = useState([]);
const [packageModal, setPackageModal] = useState(false);
const [packageLoading, setPackageLoading] = useState(false);


const fetchPackages = async () => {
  setPackageModal(true);

  setPackageLoading(true);

  try {

    const response = await axios.get(
      `${BASE_URL}packages`
    );

    const data = response.data;

    setPackages(data);

  } catch (error) {

    toast.error(
      error?.response?.data?.message ||
      "Failed to load packages"
    );

  } finally {

    setPackageLoading(false);

  }
};


const renderPaymentMethodBadge = (badge) => {
  if (!badge) return null;

  if (Number(badge.pay_now) === 1) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
        Pay Now
      </span>
    );
  }

  if (Number(badge.pay_later) === 1) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
        Pay Later
      </span>
    );
  }

  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-500">
      —
    </span>
  );
};

// ---- SELECT PACKAGE ----
const handleSelectPackage = (item) => {
  setForm((prev) => ({
    ...prev,
    lead_amount: item.amount,
    lead_type: form.lead_type,
    package_id: item.id,
    package_name: item.package_name,

    // badge details
    badge_id: item.badge_id || "",
    badge_name: item.badge?.name || "",
    benefits: item.badge?.benefits || 0,
    eligibility: item.badge?.eligibility || "",

    // ✅ payment flags (IMPORTANT)
    pay_now: Number(item.badge?.pay_now) === 1 ? 1 : 0,
    pay_later: Number(item.badge?.pay_later) === 1 ? 1 : 0,
  }));

  setPackageModal(false);
  toast.success(`Package "${item.package_name}" selected`);
};


  // ---------------- FETCH PINCODE DETAILS ------------------
  const fetchPincodeDetails = async (
  pincode
) => {
  if (!/^[0-9]{6}$/.test(pincode))
    return;

  try {
    setPinLoading(true);

    const response = await axios.get(
      `${BASE_URL}pincode/${pincode}`
    );

    const data = response.data;

    if (data?.success) {

      setForm((prev) => ({
        ...prev,

        state: data?.state || "",

        district:
          data?.district || "",

        state_code:
          data?.state_code || "",

        district_code:
          data?.district_code || "",
      }));

      setErrors((prev) => ({
        ...prev,
        pincode: "",
      }));

    } else {

      setErrors((prev) => ({
        ...prev,
        pincode:
          "Invalid pincode",
      }));

      toast.error(
        "Invalid pincode"
      );

    }

  } catch (error) {

    toast.error(
      error?.response?.data?.message ||
      "Unable to fetch pincode details"
    );

  } finally {

    setPinLoading(false);

  }
};



  // Auto-assign user type if only one option exists
  useEffect(() => {
    const options = filteredRoleOptions();
    if (options.length === 1) {
      setForm((prev) => ({
        ...prev,
        lead_type: Number(ROLE_VALUE_MAP[options[0]]),
      }));
    }
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: name === "lead_type" ? parseInt(value) : value,
    }));

    // Pincode logic stays the same
    if (name === "pincode") {
      if (value.length < 6) {
        setForm((prev) => ({ ...prev, state: "", district: "" }));
        return;
      }
      if (value.length === 6) fetchPincodeDetails(value);
    }
  };

  // ---------------- VALIDATION ------------------
  const validate = () => {
    let newErrors = {};

    if (!form.name.trim()) newErrors.name = "Name is required";
    else if (form.name.trim().length < 3)
      newErrors.name = "Name must be at least 3 characters";

   if (!form.owner_first.trim())
      newErrors.owner_first = "First name is required";

    if (!form.owner_last.trim())
      newErrors.owner_last = "Last name is required";

    if (!form.address1.trim())
      newErrors.address1 = "Address Line 1 is required";

    if (!form.phone.trim()) newErrors.phone = "Phone is required";
    else if (!/^[0-9]{10}$/.test(form.phone))
      newErrors.phone = "Phone must be 10 digits";

    if (!form.state.trim()) newErrors.state = "State is required";

    if (!form.district.trim()) newErrors.district = "District is required";

    if (!/^[0-9]{6}$/.test(form.pincode))
      newErrors.pincode = "Pincode must be 6 digits";

    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email))
      newErrors.email = "Invalid email format";

    if (!selectedProducts || selectedProducts.trim() === "") {
      newErrors.products = "Please select at least one product type";
    }

    // if (!form.password.trim()) newErrors.password = "Password is required";
    // else if (form.password.length < 6)
    //   newErrors.password = "Password must be at least 6 characters";

   if (
      Number(form.lead_type) === 5 &&
      selectedProducts.split(",").includes("warranty")
    ) {
      if (!form.lead_amount || Number(form.lead_amount) <= 0) {
        newErrors.lead_amount = "Please select a package";
      }
    }

    if (!form.lead_type)
      newErrors.lead_type = "Please select a lead type";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const getCompanyId = () => {
  const role = authUser?.role;

  if (role === 1) return null;                 // Super Admin
  if (role === 2) return authUser?.id || null; // Company
  if (role === 3 || role === 4)
    return authUser?.company_id || null;       // CNF / Agent

  return null;
};


  // ---------------- SUBMIT ------------------
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  setLoading(true);

  try {

    const payload = {
      ...form,

      owner_name: [
        form.owner_first,
        form.owner_middle,
        form.owner_last,
      ]
        .filter(Boolean)
        .join(" "),

      owner_first_name:
        form.owner_first,

      owner_middle_name:
        form.owner_middle,

      owner_last_name:
        form.owner_last,

      address1: form.address1,

      address2: form.address2,

      lead_amount: Number(
        form.lead_amount
      ),

      lead_type: form.lead_type,

      products: selectedProducts,

      state_in:
        form.state_code,

      district_in:
        form.district_code,

      pay_now:
        Number(form.pay_now) === 1
          ? 1
          : 0,

      pay_later:
        Number(form.pay_later) === 1
          ? 1
          : 0,

      manager_id:
        authUser?.reports_to,

      company_id:
        getCompanyId(),

      ...(sessionRole === 4 && {
        agent_id: authUser?.id,

        agent_code:
          authUser?.company_code,
      }),

      logo: authUser?.logo,

      domain: authUser?.domain,

      title: authUser?.title,
    };

    const response = await axios.post(
      `${BASE_URL}warranty/wlead/store`,
      payload,
      {
        headers: {
          "Content-Type":
            "application/json",
        },
      }
    );

    const data = response.data;

    if (
      data?.status === false &&
      data?.source === "lead"
    ) {

      toast.error(
        "Lead already exists in Warranty Mitra"
      );

      return;
    }

    if (
      data?.status === false &&
      data?.source === "company"
    ) {

      toast.error(
        data?.message ||
          "User already exists"
      );

      return;
    }

    // ✅ USER EXISTS
    if (
      data?.status === false &&
      data?.source === "org_user"
    ) {

      const user = data.data;

      const existingProducts =
        user?.products || [];

      const selected =
        selectedProducts.split(",");

      // EMI exists
      if (
        existingProducts.includes(
          "emi_locker"
        ) &&
        selected.includes(
          "emi_locker"
        )
      ) {

        toast.error(
          "User already exists in EMI Locker. Please select a different product."
        );

        return;
      }

      // Warranty exists
      if (
        existingProducts.includes(
          "warranty"
        ) &&
        selected.includes(
          "warranty"
        )
      ) {

        toast.error(
          "Lead already exists in Warranty. Please check leads in table."
        );

        return;
      }

      // EMI + Warranty exists
      if (
        existingProducts.includes(
          "emi_locker"
        ) &&
        existingProducts.includes(
          "warranty"
        ) &&
        selected.includes(
          "warranty"
        )
      ) {

        toast.error(
          "Lead already exists in Warranty. Please check leads in table."
        );

        return;
      }

      // EMI exists but Warranty selected
      if (
        existingProducts.includes(
          "emi_locker"
        ) &&
        selected.includes(
          "warranty"
        )
      ) {

        setExistingUserData(user);

        setForm((prev) => ({
          ...prev,

          name:
            user.business_name ||
            "",

          phone:
            user.phone || "",

          email:
            user.email || "",

          state:
            user.state || "",

          district:
            user.city || "",

          pincode:
            user.pincode || "",

          address1:
            user.address || form.address1 || "",

          address2:
            user.address || form.address2 || "",
        }));

        setShowExistingPopup(true);

        toast(
          "User exists in EMI Locker. Continue for Warranty?",
          {
            icon: "⚠️",
          }
        );

        return;
      }

      setExistingUserData(user);

      setShowExistingPopup(true);

      return;
    }

    // ✅ SUCCESS
    if (data?.status === true) {

      toast.success(
        "Lead created successfully!"
      );

      onCreate?.(data);

    }

    // RESET FORM
    setForm({
      name: "",

      owner_name: "",

      phone: "",

      state: "",

      district: "",

      pincode: "",

      email: "",

      password: "",

      address_full: "",

      lead_amount: "",

      status: "new",

      created_by_id:
        authUser?.id ?? "",

      created_by_name:
        authUser?.name ||
        `${authUser?.first_name ?? ""} ${
          authUser?.last_name ?? ""
        }`.trim() ||
        "",

      lead_type: "",

      state_code: "",

      district_code: "",
    });

    setErrors({});

  } catch (error) {

    toast.error(
      error?.response?.data?.message ||
      "Something went wrong"
    );

  } finally {

    setLoading(false);

  }
};


const handleContinueLead = async () => {
  try {
    setLoading(true);

    const payload = {
      ...form,

      // ✅ OVERRIDE
      company_id:
        getCompanyId(),

      is_existing_user: 1,

      existing_user_id:
        existingUserData?.id,

      manager_id:
        authUser?.reports_to,

      ...(sessionRole === 4 && {
        agent_id: authUser?.id,
      }),

      owner_name: [
        form.owner_first,
        form.owner_middle,
        form.owner_last,
      ]
        .filter(Boolean)
        .join(" "),

      products:
        selectedProducts,
    };

    const response = await axios.post(
      `${BASE_URL}warranty/wlead/store`,
      payload,
      {
        headers: {
          "Content-Type":
            "application/json",
        },
      }
    );

    const data = response.data;

    // ✅ FAILED
    if (data?.status === false) {

      toast.error(
        data?.message || "Failed"
      );

      return;
    }

    // ✅ SUCCESS
    toast.success(
      "Lead created successfully!"
    );

    setShowExistingPopup(false);

    // ✅ refresh parent
    onCreate?.(data);

    // ✅ reset form
    setForm({
      name: "",

      owner_first: "",

      owner_middle: "",

      owner_last: "",

      phone: "",

      state: "",

      district: "",

      pincode: "",

      email: "",

      address1: "",

      address2: "",

      lead_amount: "",

      status: "new",

      created_by_id:
        authUser?.id ?? "",

      created_by_name:
        authUser?.business_name ||
        `${authUser?.first_name ?? ""} ${
          authUser?.last_name ?? ""
        }`.trim(),

      lead_type: "",

      state_code: "",

      district_code: "",
    });

    setSelectedProducts("");

  } catch (err) {

    toast.error(
      err?.response?.data?.message ||
      "Something went wrong"
    );

  } finally {

    setLoading(false);

  }
};

  return (
    <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4 min-w-3xl">
      <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
        Create Lead
      </h2>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs md:text-sm "
      >
        {/* Name */}
        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Business Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="Full Name"
          />
          {errors.name && <span className="text-red-500 text-xs">{errors.name}</span>}
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Owner First Name</label>
          <input
            name="owner_first"
            value={form.owner_first}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="First Name"
          />
          {errors.owner_first && (
            <span className="text-red-500 text-xs">{errors.owner_first}</span>
          )}
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Owner Middle Name</label>
          <input
            name="owner_middle"
            value={form.owner_middle}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="Middle Name"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Owner Last Name</label>
          <input
            name="owner_last"
            value={form.owner_last}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="Last Name"
          />
          {errors.owner_last && (
            <span className="text-red-500 text-xs">{errors.owner_last}</span>
          )}
        </div>


        {/* Phone */}
        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Phone</label>
          <input
            name="phone"
            value={form.phone}
            inputMode="numeric"        // 📱 mobile keypad
            pattern="[0-9]*"           // allow digits only
            maxLength={10}             // 🔒 max 10 digits
            placeholder="Phone Number"
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            onChange={(e) => {
              const digitsOnly = e.target.value.replace(/\D/g, ""); // remove non-digits
              if (digitsOnly.length <= 10) {
                setForm((prev) => ({
                  ...prev,
                  phone: digitsOnly,
                }));
              }
            }}
          />

          {errors.phone && <span className="text-red-500 text-xs">{errors.phone}</span>}
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Pincode</label>

          <input
            name="pincode"
            type="number"
            value={form.pincode}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="Pincode"
          />

          {/* Error message */}
          {errors.pincode && (
            <span className="text-red-500 text-xs">{errors.pincode}</span>
          )}

          {/* Fetching loader */}
          {pinLoading && (
            <span className="text-blue-500 text-xs">Fetching...</span>
          )}
        </div>

        {/* State */}
        <div className="flex flex-col gap-1">
        <label className="text-slate-600">State</label>
        <input
          name="state"
          value={form.state}
          readOnly
          className="border border-slate-200 bg-gray-100 rounded-lg px-2 py-1.5"
          placeholder="State"
        />
        {errors.state && <span className="text-red-500 text-xs">{errors.state}</span>}
      </div>


        {/* District */}
       <div className="flex flex-col gap-1">
          <label className="text-slate-600">District</label>
          <input
            name="district"
            value={form.district}
            readOnly
            className="border border-slate-200 bg-gray-100 rounded-lg px-2 py-1.5"
            placeholder="District"
          />
          {errors.district && (
            <span className="text-red-500 text-xs">{errors.district}</span>
          )}
        </div>

        {/* Email */}
        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Email</label>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="Email Address"
          />
          {errors.email && <span className="text-red-500 text-xs">{errors.email}</span>}
        </div>

        {/* Password */}
        {/* <div className="flex flex-col gap-1">
          <label className="text-slate-600">Password</label>
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="Password"
          />
          {errors.password && <span className="text-red-500 text-xs">{errors.password}</span>}
        </div> */}

        {/* Lead Amount */}
        {/* Package Selection */}
        


        {/* Status */}
        {/* <div className="flex flex-col gap-1">
          <label className="text-slate-600">Status</label>
          <select
            name="status"
            value={form.status}
            disabled
            className="border border-slate-200 rounded-lg px-2 py-1 bg-gray-100 cursor-not-allowed"
          >
            <option value={form.status}>
              {STATUSES.find((s) => s.value === form.status)?.label || "New"}
            </option>
          </select>
        </div> */}

        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Product Type</label>

          <div className="flex gap-2 flex-wrap">
            {["warranty"].map((type) => {
              const isActive = selectedProducts.split(",").includes(type);

              return (
                <button
                  key={type}
                  type="button"
                  onClick={() => toggleProductType(type)}
                  className={`px-4 py-1.5 rounded-full text-xs font-semibold border transition
                    ${
                      isActive
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-white text-slate-600 border-slate-300 hover:bg-slate-100"
                    }
                  `}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </button>
              );
            })}
          </div>

          {errors.products && (
            <span className="text-red-500 text-xs">{errors.products}</span>
          )}
        </div>

        {/* Lead For (Role Dropdown) */}
        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Lead For</label>

          <div className="flex gap-2">
            {filteredRoleOptions().map((opt) => {
              const value = Number(ROLE_VALUE_MAP[opt]);
              const isActive = form.lead_type === value;
              const isDisabled =
                filteredRoleOptions().length === 1 && authUser?.role !== 1;

              return (
                <button
                  key={opt}
                  type="button"
                  disabled={isDisabled}
                  onClick={() =>
                    setForm((prev) => ({
                      ...prev,
                      lead_type: value,
                    }))
                  }
                  className={`
                    px-4 py-1.5 rounded-full text-xs font-semibold border transition
                    ${
                      isActive
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-white text-slate-600 border-slate-300 hover:bg-slate-100"
                    }
                    ${isDisabled ? "opacity-60 cursor-not-allowed" : ""}
                  `}
                >
                  {opt.charAt(0).toUpperCase() + opt.slice(1)}
                </button>
              );
            })}
          </div>

          {errors.lead_type && (
            <span className="text-red-500 text-xs">{errors.lead_type}</span>
          )}
        </div>



        {Number(form.lead_type) === 5 && selectedProducts.includes("warranty") && (
          <div className="flex flex-col gap-1 md:col-span-2">
            <label className="text-slate-600">Package</label>

            {form.package_name ? (
              <div className="w-full border border-blue-300 bg-blue-50 px-3 py-2 rounded-lg flex justify-between">
                <div>
                  <p className="font-semibold">{form.package_name}</p>
                  <p className="w-full text-xs text-gray-600">
                    ₹{form.lead_amount} • {form.badge_name} • {form.benefits}% Extra
                  </p>
                </div>

                <button
                  type="button"
                  className="text-red-600 text-xs"
                  onClick={() =>
                    setForm((prev) => ({
                      ...prev,
                      lead_amount: "",
                      package_id: "",
                      package_name: "",
                      badge_name: "",
                      benefits: "",
                    }))
                  }
                >
                  Remove
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={fetchPackages}
                className="bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition text-sm"
              >
                Select Package
              </button>
            )}

            {errors.lead_amount && (
              <span className="text-red-500 text-xs">{errors.lead_amount}</span>
            )}
          </div>
        )}



        <div className="flex gap-3">
          <div className="flex flex-col gap-1 md:col-span-2">
          <label className="text-slate-600">Address Line 1</label>
          <input
            name="address1"
            value={form.address1}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="House no, street, area"
          />
          {errors.address1 && (
            <span className="text-red-500 text-xs">{errors.address1}</span>
          )}
        </div>

        
        </div>

        <div className="flex flex-col gap-1 md:col-span-2">
          <label className="text-slate-600">Address Line 2</label>
          <input
            name="address2"
            value={form.address2}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-1.5"
            placeholder="Landmark, locality (optional)"
          />
        </div>


        {/* Submit Button */}
        <div className="p-4 m-1">
          <button
          type="submit"
          disabled={loading}
          className="md:col-span-2 bg-blue-600 text-white py-2 px-3 rounded-lg hover:bg-blue-700 transition text-sm"
        >
          {loading ? "Saving..." : "Save Lead"}
        </button>
        </div>
      </form>

      {/* PACKAGE MODAL */}
      {packageModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-4">
              <h3 className="text-lg font-semibold mb-3">Choose a Package</h3>

              {packageLoading ? (
                <RegularLoader/>
              ) : (
                <div className="grid grid-cols-3 lg:grid-cols-1 gap-3 max-h-90 overflow-y-auto">
                  {packages.map((pkg) => (
                    // <div
                    //   key={pkg.id}
                    //   onClick={() => handleSelectPackage(pkg)}
                    //   className="cursor-pointer border border-gray-300 rounded-xl p-4 hover:border-blue-500 hover:bg-blue-50 transition duration-200 shadow-sm"
                    // >
                    //   {/* Package Title */}
                    //   <h4 className="text-lg font-semibold text-gray-800">
                    //     {pkg.package_name} (₹{pkg.amount}/{pkg.validity_days} Days)
                    //   </h4>

                    //   {/* Amount & Validity
                    //   <div className="mt-1 text-sm text-gray-700">
                    //     <p><span className="font-semibold">Amount: </span></p>
                    //     <p><span className="font-semibold">Validity: </span></p>
                    //   </div> */}

                    //   {/* Badge Section */}
                    //   {pkg.badge && (
                    //     <div className="mt-3 p-3 rounded-lg border border-gray-200">
                          
                    //       {/* Badge Name Highlight */}
                    //       <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
                    //         {pkg.badge.name}
                    //       </span>

                    //       <p className="text-xs text-gray-700 mt-2">
                    //         {pkg.badge.description}
                    //       </p>

                    //       <div className="text-xs text-gray-700 mt-2 space-y-1">
                    //         <p>
                    //           <span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users
                    //         </p>
                    //         <p>
                    //           <span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra
                    //         </p>
                    //       </div>
                    //     </div>
                    //   )}

                    // </div>

                    <div
                      key={pkg.id}
                      onClick={() => handleSelectPackage(pkg)}
                      className="group cursor-pointer border border-slate-200 rounded-2xl p-4 hover:border-blue-500 hover:shadow-lg transition-all duration-200 bg-white"
                    >
                      {/* Header */}
                      <div className="flex justify-between items-start mb-2">
                        <h4 className="text-base font-semibold text-slate-800">
                          {pkg.package_name}
                        </h4>

                        {renderPaymentMethodBadge(pkg.badge)}
                      </div>

                      {/* Price */}
                      <p className="text-sm text-slate-600">
                        ₹<span className="font-semibold">{pkg.amount}</span>
                        <span className="text-xs text-slate-400">
                          {" "}
                          / {pkg.validity_days} Days
                        </span>
                      </p>

                      {/* Badge Info */}
                      {pkg.badge && (
                        <div className="mt-3 rounded-xl bg-slate-50 p-3 border border-slate-200">
                          <div className="flex justify-between items-center">
                            <span className="text-xs font-semibold text-blue-700 bg-blue-100 px-2 py-0.5 rounded-full">
                              {pkg.badge.name}
                            </span>

                            <span className="text-xs text-slate-500">
                              {pkg.badge.benefits}% Extra
                            </span>
                          </div>

                          <p className="text-xs text-slate-600 mt-2 line-clamp-2">
                            {pkg.badge.description}
                          </p>

                          <div className="mt-2 text-xs text-slate-600 space-y-1">
                            <p>
                              <span className="font-medium">Eligibility:</span>{" "}
                              {pkg.badge.eligibility} Users
                            </p>
                          </div>
                        </div>
                      )}

                      {/* Hover CTA */}
                      <div className="mt-3 text-xs text-blue-600 font-medium opacity-0 group-hover:opacity-100 transition">
                        Click to select →
                      </div>
                    </div>

                  ))}
                </div>
              )}

              <button
                onClick={() => setPackageModal(false)}
                className="w-full mt-4 py-2 text-center bg-gray-300 rounded-lg hover:bg-gray-400"
              >
                Close
              </button>
            </div>
          </div>
        )}

      {showExistingPopup && existingUserData && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center z-50 p-4 transition-all">
          <div className="bg-white rounded-2xl w-full max-w-xl shadow-2xl overflow-hidden border border-gray-100 animate-in fade-in zoom-in duration-200">
            
            {/* Header Section with Icon */}
            <div className="bg-amber-50 p-6 flex items-start gap-4 border-b border-amber-100">
              <div className="bg-amber-100 p-2 rounded-full">
                <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Lead Already Exists</h3>
                <p className="text-sm text-gray-500">We found a matching record in our system.</p>
              </div>
            </div>

            {/* Data Body */}
            <div className="p-6">
              <div className="grid grid-cols-2 gap-4 bg-gray-50 rounded-xl p-4 mb-6 border border-gray-100">
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Business Name</p>
                  <p className="text-sm font-medium text-gray-800">{existingUserData.business_name}</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Retailer Code</p>
                  <p className="text-sm font-medium text-gray-800">{existingUserData.org_code}</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Phone Number</p>
                  <p className="text-sm font-medium text-gray-800">{existingUserData.phone}</p>
                </div>
                
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Email Address</p>
                  <p className="text-sm font-medium text-gray-800 truncate">{existingUserData.email}</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">District</p>
                  <p className="text-sm font-medium text-gray-800">{existingUserData.city}</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">State</p>
                  <p className="text-sm font-medium text-gray-800">{existingUserData.state}</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Pincode</p>
                  <p className="text-sm font-medium text-gray-800">{existingUserData.pincode}</p>
                </div>
              </div>

              <p className="text-gray-600 text-center text-sm leading-relaxed">
                Would you like to continue using this lead for <span className="font-semibold text-blue-600">Warranty Mitra</span>?
              </p>
            </div>

            {/* Footer Actions */}
            <div className="px-6 py-4 bg-gray-50 flex flex-row gap-3">
              <button
                onClick={() => setShowExistingPopup(false)}
                className="flex-1 px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 active:scale-95 transition-all shadow-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleContinueLead}
                disabled={loading}
                className="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 active:scale-95 transition-all shadow-md shadow-blue-200 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {loading ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    Processing...
                  </>
                ) : (
                  "Yes, Continue"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


// *****************************************original code******************************************************

// import React, { useState, useEffect } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// import toast from "react-hot-toast";
// import RegularLoader from "../../Component/Loader/RegularLoader";
// import { BASE_URL, GET_PINCODE } from "../../config/api";

// export default function CreateLeadForm({ onCreate }) {

//   const authUser = JSON.parse(localStorage.getItem("authUserData"));
//   const sessionRole = authUser?.role;

//   const ROLE_OPTIONS = ["company", "agent", "retailer"];
 
//   const [selectedProducts, setSelectedProducts] = useState("");


//   const toggleProductType = (type) => {
//   setSelectedProducts((prev) => {
//     const current = prev ? prev.split(",") : [];

//     if (current.includes(type)) {
//       // remove
//       const updated = current.filter((t) => t !== type);
//       return updated.join(",");
//     } else {
//       // add
//       return [...current, type].join(",");
//     }
//   });
// };


//   // Filter role list based on logged-in user type
//   const ROLE_VALUE_MAP = {
//     MCP: 2,
//     CP: 4,
//     ARP: 5,
//   };

//   const applyHandleRestriction = (options) => {
//     const isSalesCNF =
//       authUser?.role === 3 && authUser?.type_of_user === "sales";

//     // If not sales CNF or no handle → keep existing behavior
//     if (!isSalesCNF || !authUser?.handle?.length) {
//       return options;
//     }

//     // Normalize handle values
//     const allowed = authUser.handle
//       .flatMap(item => item.split(","))
//       .map(r => r.trim().toLowerCase());

//     return options.filter(opt => allowed.includes(opt));
//   };


//   // Keep your filteredRoleOptions logic as is
//   const filteredRoleOptions = () => {
//   const role = authUser?.role;
//   const handle = authUser?.handle || [];
//   const handles = Array.isArray(handle) ? handle : [handle];
//   let options = [];

//   // ✅ FIX HERE
//   if (role === 1) options = ["MCP"]; // only company

//   if (role === 2) options = ["CP"];
//   if (role === 4) options = ["ARP"];

//   if (role === 3) {
//     if (handles.includes("AGENT") && handles.includes("RETAILER")) {
//       return ["agent", "retailer"];
//     }
//     if (handles.includes("AGENT")) return ["agent"];
//     if (handles.includes("RETAILER")) return ["retailer"];
//   }

//   return applyHandleRestriction(options);
// };

//   const [form, setForm] = useState({
//   name: "",
//   owner_first: "",
//   owner_middle: "",
//   owner_last: "",
//   phone: "",
//   state: "",
//   district: "",
//   pincode: "",
//   email: "",
//   address1: "",
//   address2: "",
//   lead_amount: "",
//   status: STATUSES[0]?.value || "new",
//   created_by_id: authUser?.id ?? "",
//   created_by_name:
//     authUser?.business_name ||
//     `${authUser?.first_name ?? ""} ${authUser?.last_name ?? ""}`.trim(),
//   lead_type: "",
//   products:"",
// });


//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [pinLoading, setPinLoading] = useState(false);
//   const [packages, setPackages] = useState([]);
// const [packageModal, setPackageModal] = useState(false);
// const [packageLoading, setPackageLoading] = useState(false);


// const fetchPackages = async () => {
//   setPackageModal(true);
//   setPackageLoading(true);

//   try {
//     const res = await fetch(`${BASE_URL}packages`);
//     const data = await res.json();
//     setPackages(data);
//   } catch (error) {
//     toast.error("Failed to load packages");
//   } finally {
//     setPackageLoading(false);
//   }
// };


// const renderPaymentMethodBadge = (badge) => {
//   if (!badge) return null;

//   if (Number(badge.pay_now) === 1) {
//     return (
//       <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
//         Pay Now
//       </span>
//     );
//   }

//   if (Number(badge.pay_later) === 1) {
//     return (
//       <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
//         Pay Later
//       </span>
//     );
//   }

//   return (
//     <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-500">
//       —
//     </span>
//   );
// };

// // ---- SELECT PACKAGE ----
// const handleSelectPackage = (item) => {
//   setForm((prev) => ({
//     ...prev,
//     lead_amount: item.amount,
//     lead_type: form.lead_type,
//     package_id: item.id,
//     package_name: item.package_name,

//     // badge details
//     badge_id: item.badge_id || "",
//     badge_name: item.badge?.name || "",
//     benefits: item.badge?.benefits || 0,
//     eligibility: item.badge?.eligibility || "",

//     // ✅ payment flags (IMPORTANT)
//     pay_now: Number(item.badge?.pay_now) === 1 ? 1 : 0,
//     pay_later: Number(item.badge?.pay_later) === 1 ? 1 : 0,
//   }));

//   setPackageModal(false);
//   toast.success(`Package "${item.package_name}" selected`);
// };


//   // ---------------- FETCH PINCODE DETAILS ------------------
//   const fetchPincodeDetails = async (pincode) => {
//   if (!/^[0-9]{6}$/.test(pincode)) return;

//   try {
//     setPinLoading(true);

//     const res = await fetch(`${BASE_URL}pincode/${pincode}`);
//     const data = await res.json();

//     if (data.success) {
//       setForm((prev) => ({
//         ...prev,
//         state: data.state || "",
//         district: data.district || "",
//         state_code: data.state_code || "",      // 👈 SAVE HERE
//         district_code: data.district_code || "", // 👈 SAVE HERE
//       }));

//       setErrors((prev) => ({ ...prev, pincode: "" }));
//     } else {
//       setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//       toast.error("Invalid pincode");
//     }
//   } catch (error) {
//     toast.error("Unable to fetch pincode details");
//   } finally {
//     setPinLoading(false);
//   }
// };



//   // Auto-assign user type if only one option exists
//   useEffect(() => {
//     const options = filteredRoleOptions();
//     if (options.length === 1) {
//       setForm((prev) => ({
//         ...prev,
//         lead_type: Number(ROLE_VALUE_MAP[options[0]]),
//       }));
//     }
//   }, []);


//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({
//       ...prev,
//       [name]: name === "lead_type" ? parseInt(value) : value,
//     }));

//     // Pincode logic stays the same
//     if (name === "pincode") {
//       if (value.length < 6) {
//         setForm((prev) => ({ ...prev, state: "", district: "" }));
//         return;
//       }
//       if (value.length === 6) fetchPincodeDetails(value);
//     }
//   };

//   // ---------------- VALIDATION ------------------
//   const validate = () => {
//     let newErrors = {};

//     if (!form.name.trim()) newErrors.name = "Name is required";
//     else if (form.name.trim().length < 3)
//       newErrors.name = "Name must be at least 3 characters";

//    if (!form.owner_first.trim())
//       newErrors.owner_first = "First name is required";

//     if (!form.owner_last.trim())
//       newErrors.owner_last = "Last name is required";

//     if (!form.address1.trim())
//       newErrors.address1 = "Address Line 1 is required";

//     if (!form.phone.trim()) newErrors.phone = "Phone is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       newErrors.phone = "Phone must be 10 digits";

//     if (!form.state.trim()) newErrors.state = "State is required";

//     if (!form.district.trim()) newErrors.district = "District is required";

//     if (!/^[0-9]{6}$/.test(form.pincode))
//       newErrors.pincode = "Pincode must be 6 digits";

//     if (form.email && !/^\S+@\S+\.\S+$/.test(form.email))
//       newErrors.email = "Invalid email format";

//     // if (!form.password.trim()) newErrors.password = "Password is required";
//     // else if (form.password.length < 6)
//     //   newErrors.password = "Password must be at least 6 characters";

//    if (
//       Number(form.lead_type) === 5 &&
//       selectedProducts.split(",").includes("warranty")
//     ) {
//       if (!form.lead_amount || Number(form.lead_amount) <= 0) {
//         newErrors.lead_amount = "Please select a package";
//       }
//     }

//     if (!form.lead_type)
//       newErrors.lead_type = "Please select a lead type";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };


//   const getCompanyId = () => {
//   const role = authUser?.role;

//   if (role === 1) return null;                 // Super Admin
//   if (role === 2) return authUser?.id || null; // Company
//   if (role === 3 || role === 4)
//     return authUser?.company_id || null;       // CNF / Agent

//   return null;
// };


//   // ---------------- SUBMIT ------------------
//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!validate()) return;
//   setLoading(true);

//   try {
//     const response = await fetch(
//       `${BASE_URL}warranty/wlead/store`,
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...form,

//            owner_name: [
//             form.owner_first,
//             form.owner_middle,
//             form.owner_last,
//           ].filter(Boolean).join(" "),
//           owner_first_name:form.owner_first,    
//           owner_middle_name:form.owner_middle,    
//           owner_last_name:form.owner_last, 
//           address1: form.address1,
//           address2: form.address2,
//           lead_amount: Number(form.lead_amount),
//           lead_type: form.lead_type, // 👈 pass selected lead type correctly
//           products: selectedProducts,
//           state_in: form.state_code,
//           district_in: form.district_code,
//           pay_now: Number(form.pay_now) === 1 ? 1 : 0,
//           pay_later: Number(form.pay_later) === 1 ? 1 : 0,
//           manager_id: authUser?.reports_to,
//           company_id: getCompanyId(),
//           ...(sessionRole === 4 && {
//             agent_id: authUser?.id,
//             agent_code: authUser?.company_code,
//           }),
//           logo:authUser?.logo,
//           domain: authUser?.domain,
//           title: authUser?.title,
//         }),
//       }
//     );

//     const data = await response.json();

//     if (!response.ok) {
//       // Check for validation errors
//       if (data?.errors) {
//         // Convert all field errors into a single message
//         const messages = Object.values(data.errors)
//           .flat() // flatten arrays
//           .join(", "); // join multiple messages

//         toast.error(messages);
//       } else {
//         toast.error(data?.message || "Failed to create lead");
//       }
//       return;
//     }

//     toast.success("Lead created successfully!");
//     onCreate && onCreate(data);

//     // Reset form except auto fields
//     setForm({
//       name: "",
//       owner_name: "",
//       phone: "",
//       state: "",
//       district: "",
//       pincode: "",
//       email: "",
//       password: "",
//       address_full: "",
//       lead_amount: "",
//       status: "new",
//       created_by_id: authUser?.id ?? "",
//       created_by_name: authUser?.name || `${authUser?.first_name ?? ""} ${authUser?.last_name ?? ""}`.trim() || "",
//       lead_type: "",
//       state_code: "",        // reset codes
//       district_code: "",
//     });

//     setErrors({});
//   } catch (error) {
//     toast.error("Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// };

//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4 min-w-3xl">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>

//       <form
//         onSubmit={handleSubmit}
//         className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs md:text-sm "
//       >
//         {/* Name */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Business Name</label>
//           <input
//             name="name"
//             value={form.name}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Full Name"
//           />
//           {errors.name && <span className="text-red-500 text-xs">{errors.name}</span>}
//         </div>

//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Owner First Name</label>
//           <input
//             name="owner_first"
//             value={form.owner_first}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="First Name"
//           />
//           {errors.owner_first && (
//             <span className="text-red-500 text-xs">{errors.owner_first}</span>
//           )}
//         </div>

//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Owner Middle Name</label>
//           <input
//             name="owner_middle"
//             value={form.owner_middle}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Middle Name"
//           />
//         </div>

//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Owner Last Name</label>
//           <input
//             name="owner_last"
//             value={form.owner_last}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Last Name"
//           />
//           {errors.owner_last && (
//             <span className="text-red-500 text-xs">{errors.owner_last}</span>
//           )}
//         </div>


//         {/* Phone */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Phone</label>
//           <input
//             name="phone"
//             value={form.phone}
//             inputMode="numeric"        // 📱 mobile keypad
//             pattern="[0-9]*"           // allow digits only
//             maxLength={10}             // 🔒 max 10 digits
//             placeholder="Phone Number"
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             onChange={(e) => {
//               const digitsOnly = e.target.value.replace(/\D/g, ""); // remove non-digits
//               if (digitsOnly.length <= 10) {
//                 setForm((prev) => ({
//                   ...prev,
//                   phone: digitsOnly,
//                 }));
//               }
//             }}
//           />

//           {errors.phone && <span className="text-red-500 text-xs">{errors.phone}</span>}
//         </div>

//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Pincode</label>

//           <input
//             name="pincode"
//             type="number"
//             value={form.pincode}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Pincode"
//           />

//           {/* Error message */}
//           {errors.pincode && (
//             <span className="text-red-500 text-xs">{errors.pincode}</span>
//           )}

//           {/* Fetching loader */}
//           {pinLoading && (
//             <span className="text-blue-500 text-xs">Fetching...</span>
//           )}
//         </div>

//         {/* State */}
//         <div className="flex flex-col gap-1">
//         <label className="text-slate-600">State</label>
//         <input
//           name="state"
//           value={form.state}
//           readOnly
//           className="border border-slate-200 bg-gray-100 rounded-lg px-2 py-1.5"
//           placeholder="State"
//         />
//         {errors.state && <span className="text-red-500 text-xs">{errors.state}</span>}
//       </div>


//         {/* District */}
//        <div className="flex flex-col gap-1">
//           <label className="text-slate-600">District</label>
//           <input
//             name="district"
//             value={form.district}
//             readOnly
//             className="border border-slate-200 bg-gray-100 rounded-lg px-2 py-1.5"
//             placeholder="District"
//           />
//           {errors.district && (
//             <span className="text-red-500 text-xs">{errors.district}</span>
//           )}
//         </div>


//         {/* Pincode */}
        


//         {/* Email */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Email</label>
//           <input
//             name="email"
//             type="email"
//             value={form.email}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Email Address"
//           />
//           {errors.email && <span className="text-red-500 text-xs">{errors.email}</span>}
//         </div>

//         {/* Password */}
//         {/* <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Password</label>
//           <input
//             name="password"
//             type="password"
//             value={form.password}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Password"
//           />
//           {errors.password && <span className="text-red-500 text-xs">{errors.password}</span>}
//         </div> */}

//         {/* Lead Amount */}
//         {/* Package Selection */}
        


//         {/* Status */}
//         {/* <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Status</label>
//           <select
//             name="status"
//             value={form.status}
//             disabled
//             className="border border-slate-200 rounded-lg px-2 py-1 bg-gray-100 cursor-not-allowed"
//           >
//             <option value={form.status}>
//               {STATUSES.find((s) => s.value === form.status)?.label || "New"}
//             </option>
//           </select>
//         </div> */}

//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Product Type</label>

//           <div className="flex gap-2 flex-wrap">
//             {["emi_locker", "warranty"].map((type) => {
//               const isActive = selectedProducts.split(",").includes(type);

//               return (
//                 <button
//                   key={type}
//                   type="button"
//                   onClick={() => toggleProductType(type)}
//                   className={`px-4 py-1.5 rounded-full text-xs font-semibold border transition
//                     ${
//                       isActive
//                         ? "bg-blue-600 text-white border-blue-600"
//                         : "bg-white text-slate-600 border-slate-300 hover:bg-slate-100"
//                     }
//                   `}
//                 >
//                   {type.charAt(0).toUpperCase() + type.slice(1)}
//                 </button>
//               );
//             })}
//           </div>
//         </div>

//         {/* Lead For (Role Dropdown) */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Lead For</label>

//           <div className="flex gap-2">
//             {filteredRoleOptions().map((opt) => {
//               const value = Number(ROLE_VALUE_MAP[opt]);
//               const isActive = form.lead_type === value;
//               const isDisabled =
//                 filteredRoleOptions().length === 1 && authUser?.role !== 1;

//               return (
//                 <button
//                   key={opt}
//                   type="button"
//                   disabled={isDisabled}
//                   onClick={() =>
//                     setForm((prev) => ({
//                       ...prev,
//                       lead_type: value,
//                     }))
//                   }
//                   className={`
//                     px-4 py-1.5 rounded-full text-xs font-semibold border transition
//                     ${
//                       isActive
//                         ? "bg-blue-600 text-white border-blue-600"
//                         : "bg-white text-slate-600 border-slate-300 hover:bg-slate-100"
//                     }
//                     ${isDisabled ? "opacity-60 cursor-not-allowed" : ""}
//                   `}
//                 >
//                   {opt.charAt(0).toUpperCase() + opt.slice(1)}
//                 </button>
//               );
//             })}
//           </div>

//           {errors.lead_type && (
//             <span className="text-red-500 text-xs">{errors.lead_type}</span>
//           )}
//         </div>



//         {Number(form.lead_type) === 5 && selectedProducts.includes("warranty") && (
//           <div className="flex flex-col gap-1 md:col-span-2">
//             <label className="text-slate-600">Package</label>

//             {form.package_name ? (
//               <div className="w-full border border-blue-300 bg-blue-50 px-3 py-2 rounded-lg flex justify-between">
//                 <div>
//                   <p className="font-semibold">{form.package_name}</p>
//                   <p className="w-full text-xs text-gray-600">
//                     ₹{form.lead_amount} • {form.badge_name} • {form.benefits}% Extra
//                   </p>
//                 </div>

//                 <button
//                   type="button"
//                   className="text-red-600 text-xs"
//                   onClick={() =>
//                     setForm((prev) => ({
//                       ...prev,
//                       lead_amount: "",
//                       package_id: "",
//                       package_name: "",
//                       badge_name: "",
//                       benefits: "",
//                     }))
//                   }
//                 >
//                   Remove
//                 </button>
//               </div>
//             ) : (
//               <button
//                 type="button"
//                 onClick={fetchPackages}
//                 className="bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition text-sm"
//               >
//                 Select Package
//               </button>
//             )}

//             {errors.lead_amount && (
//               <span className="text-red-500 text-xs">{errors.lead_amount}</span>
//             )}
//           </div>
//         )}



//         <div className="flex gap-3">
//           <div className="flex flex-col gap-1 md:col-span-2">
//           <label className="text-slate-600">Address Line 1</label>
//           <input
//             name="address1"
//             value={form.address1}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="House no, street, area"
//           />
//           {errors.address1 && (
//             <span className="text-red-500 text-xs">{errors.address1}</span>
//           )}
//         </div>

        
//         </div>

//         <div className="flex flex-col gap-1 md:col-span-2">
//           <label className="text-slate-600">Address Line 2</label>
//           <input
//             name="address2"
//             value={form.address2}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Landmark, locality (optional)"
//           />
//         </div>


//         {/* Submit Button */}
//         <div className="p-4 m-1">
//           <button
//           type="submit"
//           disabled={loading}
//           className="md:col-span-2 bg-blue-600 text-white py-2 px-3 rounded-lg hover:bg-blue-700 transition text-sm"
//         >
//           {loading ? "Saving..." : "Save Lead"}
//         </button>
//         </div>
//       </form>


//       {/* PACKAGE MODAL */}
//       {packageModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//             <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-4">
//               <h3 className="text-lg font-semibold mb-3">Choose a Package</h3>

//               {packageLoading ? (
//                 <RegularLoader/>
//               ) : (
//                 <div className="grid grid-cols-3 lg:grid-cols-1 gap-3 max-h-90 overflow-y-auto">
//                   {packages.map((pkg) => (
//                     // <div
//                     //   key={pkg.id}
//                     //   onClick={() => handleSelectPackage(pkg)}
//                     //   className="cursor-pointer border border-gray-300 rounded-xl p-4 hover:border-blue-500 hover:bg-blue-50 transition duration-200 shadow-sm"
//                     // >
//                     //   {/* Package Title */}
//                     //   <h4 className="text-lg font-semibold text-gray-800">
//                     //     {pkg.package_name} (₹{pkg.amount}/{pkg.validity_days} Days)
//                     //   </h4>

//                     //   {/* Amount & Validity
//                     //   <div className="mt-1 text-sm text-gray-700">
//                     //     <p><span className="font-semibold">Amount: </span></p>
//                     //     <p><span className="font-semibold">Validity: </span></p>
//                     //   </div> */}

//                     //   {/* Badge Section */}
//                     //   {pkg.badge && (
//                     //     <div className="mt-3 p-3 rounded-lg border border-gray-200">
                          
//                     //       {/* Badge Name Highlight */}
//                     //       <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
//                     //         {pkg.badge.name}
//                     //       </span>

//                     //       <p className="text-xs text-gray-700 mt-2">
//                     //         {pkg.badge.description}
//                     //       </p>

//                     //       <div className="text-xs text-gray-700 mt-2 space-y-1">
//                     //         <p>
//                     //           <span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users
//                     //         </p>
//                     //         <p>
//                     //           <span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra
//                     //         </p>
//                     //       </div>
//                     //     </div>
//                     //   )}

//                     // </div>

//                     <div
//                       key={pkg.id}
//                       onClick={() => handleSelectPackage(pkg)}
//                       className="group cursor-pointer border border-slate-200 rounded-2xl p-4 hover:border-blue-500 hover:shadow-lg transition-all duration-200 bg-white"
//                     >
//                       {/* Header */}
//                       <div className="flex justify-between items-start mb-2">
//                         <h4 className="text-base font-semibold text-slate-800">
//                           {pkg.package_name}
//                         </h4>

//                         {renderPaymentMethodBadge(pkg.badge)}
//                       </div>

//                       {/* Price */}
//                       <p className="text-sm text-slate-600">
//                         ₹<span className="font-semibold">{pkg.amount}</span>
//                         <span className="text-xs text-slate-400">
//                           {" "}
//                           / {pkg.validity_days} Days
//                         </span>
//                       </p>

//                       {/* Badge Info */}
//                       {pkg.badge && (
//                         <div className="mt-3 rounded-xl bg-slate-50 p-3 border border-slate-200">
//                           <div className="flex justify-between items-center">
//                             <span className="text-xs font-semibold text-blue-700 bg-blue-100 px-2 py-0.5 rounded-full">
//                               {pkg.badge.name}
//                             </span>

//                             <span className="text-xs text-slate-500">
//                               {pkg.badge.benefits}% Extra
//                             </span>
//                           </div>

//                           <p className="text-xs text-slate-600 mt-2 line-clamp-2">
//                             {pkg.badge.description}
//                           </p>

//                           <div className="mt-2 text-xs text-slate-600 space-y-1">
//                             <p>
//                               <span className="font-medium">Eligibility:</span>{" "}
//                               {pkg.badge.eligibility} Users
//                             </p>
//                           </div>
//                         </div>
//                       )}

//                       {/* Hover CTA */}
//                       <div className="mt-3 text-xs text-blue-600 font-medium opacity-0 group-hover:opacity-100 transition">
//                         Click to select →
//                       </div>
//                     </div>

//                   ))}
//                 </div>
//               )}

//               <button
//                 onClick={() => setPackageModal(false)}
//                 className="w-full mt-4 py-2 text-center bg-gray-300 rounded-lg hover:bg-gray-400"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         )}
//     </div>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// import toast from "react-hot-toast";
// import RegularLoader from "../../Component/Loader/RegularLoader";
// import { BASE_URL, GET_PINCODE } from "../../config/api";

// export default function CreateLeadForm({ onCreate }) {

//   const authUser = JSON.parse(localStorage.getItem("authUserData"));

//   const ROLE_OPTIONS = ["company", "agent", "retailer"];
 


//   // Filter role list based on logged-in user type
//   const ROLE_VALUE_MAP = {
//     company: "2",
//     agent: "4",
//     retailer: "5",
//   };

//   // Keep your filteredRoleOptions logic as is
//   const filteredRoleOptions = () => {
//   const role = authUser?.role;
//   const handle = authUser?.handle || [];

//   // Normalize handle → always array
//   const handles = Array.isArray(handle) ? handle : [handle];

//   if (role === 1) return ROLE_OPTIONS;                 // Admin
//   if (role === 2) return ["agent", "retailer"];        // Company
//   if (role === 4) return ["retailer"];                 // Agent

//   // 🔥 ROLE 3 LOGIC (NEW)
  // if (role === 3) {
  //   if (handles.includes("AGENT") && handles.includes("RETAILER")) {
  //     return ["agent", "retailer"];
  //   }
  //   if (handles.includes("AGENT")) return ["agent"];
  //   if (handles.includes("RETAILER")) return ["retailer"];
  // }


//   return [];
// };


//   const [form, setForm] = useState({
//     name: "",
//     owner_name: "",
//     phone: "",
//     state: "",
//     district: "",
//     pincode: "",
//     email: "",
//     password: 123456,
//     address_full: "",
//     lead_amount: "",
//     status: STATUSES[0]?.value || "new",
//     created_by_id: authUser?.id ?? "",
//     created_by_name: authUser?.business_name ?? authUser?.first_name ?? "",
//     lead_type: "", 
    
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [pinLoading, setPinLoading] = useState(false);
//   const [packages, setPackages] = useState([]);
// const [packageModal, setPackageModal] = useState(false);
// const [packageLoading, setPackageLoading] = useState(false);
// const isRetailerLead = Number(form.lead_type) === 5;



// const fetchPackages = async () => {
//   setPackageModal(true);
//   setPackageLoading(true);

//   try {
//     const res = await fetch(`${BASE_URL}packages`);
//     const data = await res.json();
//     setPackages(data);
//   } catch (error) {
//     toast.error("Failed to load packages");
//   } finally {
//     setPackageLoading(false);
//   }
// };

// // ---- SELECT PACKAGE ----
// const handleSelectPackage = (item) => {
//   setForm((prev) => ({
//     ...prev,
//     lead_amount: item.amount,
//     lead_type: form.lead_type,  
//     package_id: item.id,
//     package_name: item.package_name,
//     badge_id: item.badge_id || "",
//     badge_name: item.badge?.name || "",
//     benefits: item.badge?.benefits || 0,
//     eligibility: item.badge?.eligibility || "",
//   }));
//   setPackageModal(false);
//   toast.success(`Package "${item.package_name}" selected`);
// };

//   // ---------------- FETCH PINCODE DETAILS ------------------
//   const fetchPincodeDetails = async (pincode) => {
//   if (!/^[0-9]{6}$/.test(pincode)) return;

//   try {
//     setPinLoading(true);

//     const res = await fetch(`${BASE_URL}pincode/${pincode}`);
//     const data = await res.json();

//     if (data.success) {
//       setForm((prev) => ({
//         ...prev,
//         state: data.state || "",
//         district: data.district || "",
//         state_code: data.state_code || "",      // 👈 SAVE HERE
//         district_code: data.district_code || "", // 👈 SAVE HERE
//       }));

//       setErrors((prev) => ({ ...prev, pincode: "" }));
//     } else {
//       setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//       toast.error("Invalid pincode");
//     }
//   } catch (error) {
//     toast.error("Unable to fetch pincode details");
//   } finally {
//     setPinLoading(false);
//   }
// };



//   // Auto-assign user type if only one option exists
//   useEffect(() => {
//     const options = filteredRoleOptions();
//     if (options.length === 1) {
//       setForm((prev) => ({ ...prev, lead_type: ROLE_VALUE_MAP[options[0]] }));
//     }
//   }, []);


//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({
//       ...prev,
//       [name]: name === "lead_type" ? parseInt(value) : value,
//     }));

//     // Pincode logic stays the same
//     if (name === "pincode") {
//       if (value.length < 6) {
//         setForm((prev) => ({ ...prev, state: "", district: "" }));
//         return;
//       }
//       if (value.length === 6) fetchPincodeDetails(value);
//     }

//     if (name === "lead_type") {
//       const numericValue = Number(value);

//       setForm((prev) => ({
//         ...prev,
//         lead_type: numericValue,

//         // 🔥 clear package if not retailer
//         ...(numericValue !== 5 && {
//           package_id: "",
//           package_name: "",
//           badge_id: "",
//           badge_name: "",
//           benefits: "",
//           eligibility: "",
//           lead_amount: "",
//         }),
//       }));

//       return;
//     }
//   };  




//   // ---------------- VALIDATION ------------------
//   const validate = () => {
//     let newErrors = {};

//     if (!form.name.trim()) newErrors.name = "Name is required";
//     else if (form.name.trim().length < 3)
//       newErrors.name = "Name must be at least 3 characters";

//     if (!form.owner_name.trim()) newErrors.owner_name = "Name is required";
//     else if (form.owner_name.trim().length < 3)
//       newErrors.owner_name = "Name must be at least 3 characters";

//     if (!form.phone.trim()) newErrors.phone = "Phone is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       newErrors.phone = "Phone must be 10 digits";

//     if (!form.state.trim()) newErrors.state = "State is required";

//     if (!form.district.trim()) newErrors.district = "District is required";

//     if (!/^[0-9]{6}$/.test(form.pincode))
//       newErrors.pincode = "Pincode must be 6 digits";

//     if (form.email && !/^\S+@\S+\.\S+$/.test(form.email))
//       newErrors.email = "Invalid email format";

//     // if (!form.password.trim()) newErrors.password = "Password is required";
//     // else if (form.password.length < 6)
//     //   newErrors.password = "Password must be at least 6 characters";

//     if (!form.address_full.trim())
//       newErrors.address_full = "Address cannot be empty";

//     if (!form.lead_amount || Number(form.lead_amount) <= 0)
//       newErrors.lead_amount = "Enter a valid amount";

//     if (!form.lead_type)
//       newErrors.lead_type = "Please select a lead type";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ---------------- SUBMIT ------------------
//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!validate()) return;
//   setLoading(true);

//   try {
//     const response = await fetch(
//       `${BASE_URL}warranty/wlead/store`,
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...form,
//           lead_amount: Number(form.lead_amount),
//           lead_type: form.lead_type, // 👈 pass selected lead type correctly
//           state_in: form.state_code,
//           district_in: form.district_code,
//           manager_id:authUser?.reports_to,
//           company_id:authUser?.company_id,
//         }),
//       }
//     );

//     const data = await response.json();

//     if (!response.ok) {
//       // Check for validation errors
//       if (data?.errors) {
//         // Convert all field errors into a single message
//         const messages = Object.values(data.errors)
//           .flat() // flatten arrays
//           .join(", "); // join multiple messages

//         toast.error(messages);
//       } else {
//         toast.error(data?.message || "Failed to create lead");
//       }
//       return;
//     }

//     toast.success("Lead created successfully!");
//     onCreate && onCreate(data);

//     // Reset form except auto fields
//     setForm({
//       name: "",
//       owner_name: "",
//       phone: "",
//       state: "",
//       district: "",
//       pincode: "",
//       email: "",
//       password: "",
//       address_full: "",
//       lead_amount: "",
//       status: "new",
//       created_by_id: authUser?.id ?? "",
//       created_by_name: authUser?.name ?? "",
//       lead_type: "",
//       state_code: "",        // reset codes
//       district_code: "",
//     });

//     setErrors({});
//   } catch (error) {
//     toast.error("Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// };


//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>

//       <form
//         onSubmit={handleSubmit}
//         className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs md:text-sm"
//       >
//         {/* Name */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Name</label>
//           <input
//             name="name"
//             value={form.name}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Full Name"
//           />
//           {errors.name && <span className="text-red-500 text-xs">{errors.name}</span>}
//         </div>

//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Owner Name</label>
//           <input
//             name="owner_name"
//             value={form.owner_name}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Full Name"
//           />
//           {errors.owner_name && <span className="text-red-500 text-xs">{errors.owner_name}</span>}
//         </div>

//         {/* Phone */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Phone</label>
//           <input
//             name="phone"
//             value={form.phone}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Phone Number"
//           />
//           {errors.phone && <span className="text-red-500 text-xs">{errors.phone}</span>}
//         </div>

//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Pincode</label>

//           <input
//             name="pincode"
//             type="number"
//             value={form.pincode}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Pincode"
//           />

//           {/* Error message */}
//           {errors.pincode && (
//             <span className="text-red-500 text-xs">{errors.pincode}</span>
//           )}

//           {/* Fetching loader */}
//           {pinLoading && (
//             <span className="text-blue-500 text-xs">Fetching...</span>
//           )}
//         </div>

//         {/* State */}
//         <div className="flex flex-col gap-1">
//         <label className="text-slate-600">State</label>
//         <input
//           name="state"
//           value={form.state}
//           readOnly
//           className="border border-slate-200 bg-gray-100 rounded-lg px-2 py-1.5"
//           placeholder="State"
//         />
//         {errors.state && <span className="text-red-500 text-xs">{errors.state}</span>}
//       </div>


//         {/* District */}
//        <div className="flex flex-col gap-1">
//           <label className="text-slate-600">District</label>
//           <input
//             name="district"
//             value={form.district}
//             readOnly
//             className="border border-slate-200 bg-gray-100 rounded-lg px-2 py-1.5"
//             placeholder="District"
//           />
//           {errors.district && (
//             <span className="text-red-500 text-xs">{errors.district}</span>
//           )}
//         </div>


//         {/* Pincode */}
        


//         {/* Email */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Email</label>
//           <input
//             name="email"
//             type="email"
//             value={form.email}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Email Address"
//           />
//           {errors.email && <span className="text-red-500 text-xs">{errors.email}</span>}
//         </div>

//         {/* Password */}
//         {/* <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Password</label>
//           <input
//             name="password"
//             type="password"
//             value={form.password}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Password"
//           />
//           {errors.password && <span className="text-red-500 text-xs">{errors.password}</span>}
//         </div> */}

//         {/* Lead Amount */}
//         {/* Package Selection */}
        


//         {/* Status */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Status</label>
//           <select
//             name="status"
//             value={form.status}
//             disabled
//             className="border border-slate-200 rounded-lg px-2 py-1 bg-gray-100 cursor-not-allowed"
//           >
//             <option value={form.status}>
//               {STATUSES.find((s) => s.value === form.status)?.label || "New"}
//             </option>
//           </select>
//         </div>

//         {/* Lead For (Role Dropdown) */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Lead For</label>
//           <select
//             name="lead_type"
//             value={form.lead_type}
//             onChange={handleChange}
//             disabled={filteredRoleOptions().length === 1}
//           >
//             <option value="">Select Type</option>
//             {filteredRoleOptions().map((opt) => (
//               <option key={opt} value={ROLE_VALUE_MAP[opt]}>
//                 {opt.charAt(0).toUpperCase() + opt.slice(1)}
//               </option>
//             ))}
//           </select>


//           {errors.lead_type && (
//             <span className="text-red-500 text-xs">{errors.lead_type}</span>
//           )}
//         </div>


//         {isRetailerLead && (
//           <div className="flex flex-col gap-1 md:col-span-2">
//             <label className="text-slate-600">Package</label>

//             {form.package_name ? (
//               <div className="w-full border border-blue-300 bg-blue-50 px-3 py-2 rounded-lg flex justify-between">
//                 <div>
//                   <p className="font-semibold">{form.package_name}</p>
//                   <p className="w-full text-xs text-gray-600">
//                     ₹{form.lead_amount} • {form.validity_days} days • {form.badge_name} • {form.benefits}% Extra
//                   </p>
//                 </div>

//                 <button
//                   type="button"
//                   className="text-red-600 text-xs"
//                   onClick={() =>
//                     setForm((prev) => ({
//                       ...prev,
//                       lead_amount: "",
//                       package_name: "",
//                       validity_days: "",
//                       badge_name: "",
//                       benefits: "",
//                     }))
//                   }
//                 >
//                   Remove
//                 </button>
//               </div>
//             ) : (
//               <button
//                 type="button"
//                 onClick={fetchPackages}
//                 className="bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition text-sm"
//               >
//                 Select Package
//               </button>
//             )}

//             {errors.lead_amount && (
//               <span className="text-red-500 text-xs">{errors.lead_amount}</span>
//             )}
//           </div>
//         )}



//         <div className="flex flex-col gap-1 md:col-span-2">
//           <label className="text-slate-600">Full Address</label>
//           <textarea
//             name="address_full"
//             value={form.address_full}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5 h-20"
//             placeholder="Complete Address"
//           />
//           {errors.address_full && (
//             <span className="text-red-500 text-xs">{errors.address_full}</span>
//           )}
//         </div>

//         {/* Submit Button */}
//         <button
//           type="submit"
//           disabled={loading}
//           className="md:col-span-2 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition text-sm"
//         >
//           {loading ? "Saving..." : "Save Lead"}
//         </button>
//       </form>


//       {/* PACKAGE MODAL */}
//       {packageModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//             <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-4">
//               <h3 className="text-lg font-semibold mb-3">Choose a Package</h3>

//               {packageLoading ? (
//                 <RegularLoader/>
//               ) : (
//                 <div className="grid grid-cols-3 gap-3 max-h-90 overflow-y-auto">
//                   {packages.map((pkg) => (
//                     <div
//                       key={pkg.id}
//                       onClick={() => handleSelectPackage(pkg)}
//                       className="cursor-pointer border border-gray-300 rounded-xl p-4 hover:border-blue-500 hover:bg-blue-50 transition duration-200 shadow-sm"
//                     >
//                       {/* Package Title */}
//                       <h4 className="text-lg font-semibold text-gray-800">
//                         {pkg.package_name} (₹{pkg.amount}/{pkg.validity_days} Days)
//                       </h4>

//                       {/* Amount & Validity
//                       <div className="mt-1 text-sm text-gray-700">
//                         <p><span className="font-semibold">Amount: </span></p>
//                         <p><span className="font-semibold">Validity: </span></p>
//                       </div> */}

//                       {/* Badge Section */}
//                       {pkg.badge && (
//                         <div className="mt-3 p-3 rounded-lg border border-gray-200">
                          
//                           {/* Badge Name Highlight */}
//                           <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
//                             {pkg.badge.name}
//                           </span>

//                           <p className="text-xs text-gray-700 mt-2">
//                             {pkg.badge.description}
//                           </p>

//                           <div className="text-xs text-gray-700 mt-2 space-y-1">
//                             <p>
//                               <span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users
//                             </p>
//                             <p>
//                               <span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra
//                             </p>
//                           </div>
//                         </div>
//                       )}

//                     </div>
//                   ))}
//                 </div>
//               )}

//               <button
//                 onClick={() => setPackageModal(false)}
//                 className="w-full mt-4 py-2 text-center bg-gray-300 rounded-lg hover:bg-gray-400"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         )}
//     </div>
//   );
// }


// import React, { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";

// export default function CreateLeadForm({ onCreate }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     state: "",
//     district: "",
//     pincode: "",
//     email: "",
//     password: "",
//     address_full: "",
//     lead_amount: ,
//     status: "New",
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // ---------------- VALIDATION ------------------
//   const validate = () => {
//     let newErrors = {};

//     if (!form.name.trim()) newErrors.name = "Name is required";
//     else if (form.name.trim().length < 3)
//       newErrors.name = "Name must be at least 3 characters";

//     if (!form.phone.trim()) newErrors.phone = "Phone is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       newErrors.phone = "Phone must be 10 digits";

//     if (!form.state.trim()) newErrors.state = "State is required";

//     if (!form.district.trim()) newErrors.district = "District is required";

//     if (!/^[0-9]{6}$/.test(form.pincode))
//       newErrors.pincode = "Pincode must be 6 digits";

//     if (form.email && !/^\S+@\S+\.\S+$/.test(form.email))
//       newErrors.email = "Invalid email format";

//     if (!form.password.trim()) newErrors.password = "Password is required";
//     else if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";

//     if (!form.address_full.trim())
//       newErrors.address_full = "Address cannot be empty";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ---------------- SUBMIT ------------------
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return; // ❌ Stop submit if validation fails

//     setLoading(true);

//     try {
//       const response = await fetch(
//         "${BASE_URL}/warranty/wlead/store",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         }
//       );

//       const data = await response.json();

//       if (!response.ok) {
//         alert(data?.message || "Failed to create lead");
//         return;
//       }

//       onCreate && onCreate(data);

//       alert("Lead created successfully!");

//       setForm({
//         name: "",
//         phone: "",
//         state: "",
//         district: "",
//         pincode: "",
//         email: "",
//         password: "",
//         address_full: "",
//         status: "New",
//       });
//       setErrors({});
//     } catch (error) {
//       alert("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------------- UI ------------------
//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>

//       <form
//         onSubmit={handleSubmit}
//         className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs md:text-sm"
//       >
//         {/* Name */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Name</label>
//           <input
//             name="name"
//             value={form.name}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Full Name"
//           />
//           {errors.name && (
//             <span className="text-red-500 text-xs">{errors.name}</span>
//           )}
//         </div>

//         {/* Phone */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Phone</label>
//           <input
//             name="phone"
//             value={form.phone}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Phone Number"
//           />
//           {errors.phone && (
//             <span className="text-red-500 text-xs">{errors.phone}</span>
//           )}
//         </div>

//         {/* State */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">State</label>
//           <input
//             name="state"
//             value={form.state}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="State Name"
//           />
//           {errors.state && (
//             <span className="text-red-500 text-xs">{errors.state}</span>
//           )}
//         </div>

//         {/* District */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">District</label>
//           <input
//             name="district"
//             value={form.district}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="District Name"
//           />
//           {errors.district && (
//             <span className="text-red-500 text-xs">{errors.district}</span>
//           )}
//         </div>

//         {/* Pincode */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Pincode</label>
//           <input
//             name="pincode"
//             type="number"
//             value={form.pincode}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Pincode"
//           />
//           {errors.pincode && (
//             <span className="text-red-500 text-xs">{errors.pincode}</span>
//           )}
//         </div>

//         {/* Email */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Email</label>
//           <input
//             name="email"
//             type="email"
//             value={form.email}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Email Address"
//           />
//           {errors.email && (
//             <span className="text-red-500 text-xs">{errors.email}</span>
//           )}
//         </div>

//         {/* Password */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Password</label>
//           <input
//             name="password"
//             type="password"
//             value={form.password}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Password"
//           />
//           {errors.password && (
//             <span className="text-red-500 text-xs">{errors.password}</span>
//           )}
//         </div>

//         {/* Status */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Status</label>
//           <select
//             name="status"
//             value={form.status}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5 bg-white"
//           >
//             {STATUSES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Address Full */}
//         <div className="flex flex-col gap-1 md:col-span-2">
//           <label className="text-slate-600">Full Address</label>
//           <textarea
//             name="address_full"
//             value={form.address_full}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5 h-20"
//             placeholder="Complete Address"
//           ></textarea>
//           {errors.address_full && (
//             <span className="text-red-500 text-xs">
//               {errors.address_full}
//             </span>
//           )}
//         </div>

//         {/* Submit */}
//         <button
//           type="submit"
//           disabled={loading}
//           className="md:col-span-2 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition text-sm"
//         >
//           {loading ? "Saving..." : "Save Lead"}
//         </button>
//       </form>
//     </div>
//   );
// }




// import react, { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";

// export default function CreateLeadForm({ onCreate }) {
//   const [name, setName] = useState("");
//   const [owner, setOwner] = useState("");
//   const [status, setStatus] = useState("New");
//   const [value, setValue] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const numericValue = parseFloat(value) || 0;

//     if (!name.trim() || !owner.trim()) return;

//     // 🚨 Minimum value validation (₹2000)
//     if (numericValue < 2000) {
//       alert("Minimum lead value should be ₹2000");
//       return;
//     }

//     const today = new Date();
//     const createdAt = today.toISOString().slice(0, 10);

//     onCreate({
//       id: Date.now(),
//       name: name.trim(),
//       owner: owner.trim(),
//       status,
//       value: numericValue,
//       createdAt,
//     });

//     setName("");
//     setOwner("");
//     setStatus("New");
//     setValue("");
//   };

//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>

//       <form
//         onSubmit={handleSubmit}
//         className="flex flex-col gap-3 text-xs md:text-sm"
//       >
//         {/* Lead Name */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Lead Name</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="e.g. New CRM rollout"
//           />
//         </div>

//         {/* Owner */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Owner</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={owner}
//             onChange={(e) => setOwner(e.target.value)}
//             placeholder="e.g. Priya Sharma"
//           />
//         </div>

//         {/* Status */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Status</label>
//           <select
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm bg-white"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             {STATUSES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Value (₹) */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Value (₹)</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             type="number"
//             min="2000"                    // 🔥 HTML minimum
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             placeholder="Minimum value ₹2000"
//           />
//         </div>

//         {/* Save Button */}
//         <button
//           type="submit"
//           className="mt-1 inline-flex items-center justify-center rounded-lg bg-blue-600 text-white text-xs md:text-sm font-medium py-1.5 px-3 hover:bg-blue-700 transition-colors"
//         >
//           Save Lead
//         </button>
//       </form>
//     </div>
//   );
// }


// import react, { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// export default function CreateLeadForm({ onCreate }) {
//   const [name, setName] = useState("");
//   const [owner, setOwner] = useState("");
//   const [status, setStatus] = useState("New");
//   const [value, setValue] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const numericValue = parseFloat(value) || 0;
//     if (!name.trim() || !owner.trim() || numericValue <= 0) return;

//     const today = new Date();
//     const createdAt = today.toISOString().slice(0, 10);

//     onCreate({
//       id: Date.now(),
//       name: name.trim(),
//       owner: owner.trim(),
//       status,
//       value: numericValue,
//       createdAt,
//     });

//     setName("");
//     setOwner("");
//     setStatus("New");
//     setValue("");
//   };

//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>
//       <form
//         onSubmit={handleSubmit}
//         className="flex flex-col gap-3 text-xs md:text-sm"
//       >
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Lead Name</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="e.g. New CRM rollout"
//           />
//         </div>
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Owner</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={owner}
//             onChange={(e) => setOwner(e.target.value)}
//             placeholder="e.g. Priya Sharma"
//           />
//         </div>
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Status</label>
//           <select
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm bg-white"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             {STATUSES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Value (₹)</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             type="number"
//             min="0"
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             placeholder="e.g. 50000"
//           />
//         </div>
//         <button
//           type="submit"
//           className="mt-1 inline-flex items-center justify-center rounded-lg bg-blue-600 text-white text-xs md:text-sm font-medium py-1.5 px-3 hover:bg-blue-700 transition-colors"
//         >
//           Save Lead
//         </button>
//       </form>
//     </div>
//   );
// }